import React, { useRef } from 'react';

export default function InputProductsTile({ className, product, addItem, selected }) {
  const { title, category, image } = product;
  const inputRef = useRef(null);
  return (
  <div
    className={`input-products-tile posr curp bd1-s-gray:h p20 w290 h420 ${className || ''}`}
    tabIndex="0"
    ref={inputRef}
    role="button"
    aria-label="add product used"
    onClick={() => addItem(product)}
    onKeyDown={e => (e.key === 'Enter' || e.key === ' ') && inputRef.current.click()}
  >
    <div className="input-product-tile__content-wrapper h100% df fxdrc jcsb">
      <div className="input-product-tile__media h300 df aic jcc trs-trf-0.3s-eio">
        <img
          className="w100%"
          src={image?.src}
          alt={image?.alt || title}
        />
      </div>
      <div className="input-product-tile__content-wrapper trs-m-0.3s">
        <div className="fz16 fz14@md c-gray-medium mb4 lh1.5">
          { category }
        </div>
        <div className="fz16 fz14@md fw500 c-black lh1.5">
          { title }
        </div>
      </div>
    </div>
    <div className="input-products-tile__add-container posa b0 l0 p20 w100% op0 trs-op-0.5s">
      <div className="bgc-red-dark:h bgc-red c-white h50 fxb100% w100% fw600 bdn curp df jcc aic bdrs8">
        {selected ? '- Remove' : '+ Add' }
      </div>
    </div>
  </div>
  )
}